import { Injectable } from "@angular/core";
import { filter } from "rxjs/operators";

import { AppFacade, AuthService } from "@app/core/app-services";

@Injectable()
export class AuthEffect {
  constructor(private appFacade: AppFacade, private auth: AuthService) {}

  setSubscriptions() {
    this.appFacade
      .isAuthenticated()
      .pipe(filter((status) => status === false))
      .subscribe(() => this.auth.handleAuthentication());
  }
}
